import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-login-layout',
    template: `
    <router-outlet></router-outlet>
  `,
    styles: []
})
export class LoginLayoutComponent { }



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/layouts/login-layout.component.ts